import { createApp } from "vue";
import { VueReCaptcha } from 'vue-recaptcha-v3'
import App from "./App.vue";
import { recaptcha_site_key } from "./constants/envrionment";

let app = createApp(App);

app.use(VueReCaptcha, {
    siteKey: recaptcha_site_key
})

app.mount("#signupFormApp");
